import { ReloadOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import { useEffect, useState } from "react";
import apiFactory from "../../../api";
import { StoreAppModal } from "../../../components/modal/adminSetting/StoreAppModal";
import { useAdminSettingContext } from "../../../context/AdminSettingContext";
import { useInfoUser } from "../../../store/UserStore";
import { RenderMobileList } from "./RenderMobileList";

const AppList = ({ isMobile }) => {
  const { user, languageMap } = useInfoUser();
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedApp, selectedApp } = useAdminSettingContext();
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [applicationList, setApplicationList] = useState([]);
  const [isOpenAppModal, setIsOpenAppModal] = useState(false);

  const columns = [
    {
      title: `${languageMap?.["as.menu.app.table.id"] ?? "App id"}`,
      dataIndex: "appId",
      key: "appId",
      width: "150px",
    },
    {
      title: `${languageMap?.["as.menu.app.table.type"] ?? "Type"}`,
      dataIndex: "type",
      key: "type",
      width: "150px",
    },
    {
      title: `${languageMap?.["as.menu.app.table.name"] ?? "Name"}`,
      dataIndex: "name",
      key: "name",
      width: "150px",
    },
    {
      title: `${languageMap?.["as.menu.app.table.valid"] ?? "Valid version"}`,
      dataIndex: "validVersion",
      key: "validVersion",
      width: "150px",
    },
  ];

  const fetchAppList = async () => {
    setIsLoading(true);
    try {
      const result = await apiFactory.appApi.getList();

      if (result?.status === 200) {
        setApplicationList(result?.data);
      }
    } catch (error) {
      console.error("Error fetching file list data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onRemove = (record) => {
    setSelectedApplication(record);
  };

  const onDoubleClick = (record) => {
    setSelectedApplication(record);
    setIsOpenAppModal(true);
  };

  const onClick = (record) => {
    setSelectedApp(record);
  };

  const cancelModal = () => {
    setIsOpenAppModal(false);
    setSelectedApplication(null);
  };

  const getSelectedColor = (record) => {
    if (record?.appId === selectedApp?.appId) {
      return "bg-[#e1e119]";
    }
  };

  useEffect(() => {
    fetchAppList();
  }, []);

  return (
    <>
      {isMobile ? (
        <Modal
          title={
            languageMap?.["as.menu.document.table.mobileTitle"] ?? "File list"
          }
          // open={selectedProgram}
          // onCancel={() => {
          //   setSelectedProgram(null);
          // }}
          footer={null}
          centered
          width={"100%"}
        >
          <RenderMobileList
            data={applicationList}
            onRemove={onRemove}
            loading={isLoading}
            // selectedProgram={selectedProgram}
            languageMap={languageMap}
            isProgramList={false}
          />
        </Modal>
      ) : (
        <>
          <div className="file-list">
            <div
              className="my-alarm"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div className="flex justify-between gap-[10px]">
                <div className="font-semisolid">App list</div>
                <ReloadOutlined
                  className="text-[20px]"
                  onClick={fetchAppList}
                />
              </div>
              <div>
                <Button type="primary" onClick={() => setIsOpenAppModal(true)}>
                  Create app
                </Button>
              </div>
            </div>
            <div>
              <Table
                columns={columns}
                dataSource={applicationList}
                pagination={false}
                onRow={(record, index) => ({
                  onDoubleClick: (e) => onDoubleClick(record),
                  onClick: (e) => onClick(record),
                  className: getSelectedColor(record),
                  // ref:
                  //   isLoadMoreData && index === userList?.length - 1
                  //     ? lastRecordRef
                  //     : null,
                })}
                size={"middle"}
                loading={isLoading}
                rowKey={(record) => record.key}
                rowClassName="admin-setting-table-row"
                scroll={{
                  x: 700,
                  y: 300,
                }}
              />
            </div>
          </div>
        </>
      )}

      {isOpenAppModal && (
        <StoreAppModal
          isModalOpen={isOpenAppModal}
          title={selectedApplication ? "Update app" : "Create app"}
          selectedApplication={selectedApplication}
          cancelModal={cancelModal}
          setApplicationList={setApplicationList}
          applicationList={applicationList}
        />
      )}
    </>
  );
};
export { AppList };
